import React, { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';

import {NOTE_MAX_LENGTH, NOTE_TEST_ID} from '../../const';

import styles from './styles.module.scss';

type NoteProps = {
  note: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export const Note: FC<NoteProps> = ({ note, onChange }) => {
  const [t] = useTranslation();

  return (
    <>
      <h3 className={styles.sectionInfo}>{t('note.title')}</h3>
      <input
        data-testid={NOTE_TEST_ID}
        className={styles.input}
        placeholder={t('note.placeholder')}
        name="note"
        type="text"
        value={note}
        maxLength={NOTE_MAX_LENGTH}
        onChange={onChange}
      />
    </>
  );
};
